@if (erreurRecuperation()) {
  <div class="custom-alert custom-alert-sm">
    {{'GLOBAL.ERREUR_RECUP_DONNEES' | translate }}
  </div>
}

@if (!erreurRecuperation()) {
  <div class="zone-container">

    <!-- ── Form panel ── -->
    <form class="zone-form" [formGroup]="form" (ngSubmit)="onSubmit()">

      <div class="zone-fields">

        <!-- Name -->
        <div class="zone-field zone-field--name">
          <mat-form-field appearance="outline" class="zone-mat-field" subscriptSizing="dynamic">
            <mat-label>{{'GLOBAL.NOM' | translate}} <span class="zone-required"></span></mat-label>
            <input matInput formControlName="nom" maxlength="256" [placeholder]="'GLOBAL.NOM' | translate" />
            @if (nomInvalide()) {
              <mat-error>{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate}}</mat-error>
            }
          </mat-form-field>
        </div>

        <!-- Toggle -->
        <div class="zone-field zone-field--toggle">
          <span class="zone-label">{{'GLOBAL.ACTIF' | translate}}</span>
          <mat-slide-toggle formControlName="isActif" color="primary" class="zone-toggle">
            {{ isActifValue() ? ('GLOBAL.OUI' | translate) : ('GLOBAL.NON' | translate) }}
          </mat-slide-toggle>
        </div>

        <!-- Numeric fields -->
        <div class="zone-field">
          <mat-form-field appearance="outline" class="zone-mat-field" subscriptSizing="dynamic">
            <mat-label>{{'ZONE.BURDEN' | translate}}</mat-label>
            <input matInput type="number" formControlName="burden" step="0.1" min="0" />
          </mat-form-field>
        </div>

        <div class="zone-field">
          <mat-form-field appearance="outline" class="zone-mat-field" subscriptSizing="dynamic">
            <mat-label>{{'ZONE.SPACING' | translate}}</mat-label>
            <input matInput type="number" formControlName="spacing" step="0.1" min="0" />
          </mat-form-field>
        </div>

        <div class="zone-field">
          <mat-form-field appearance="outline" class="zone-mat-field" subscriptSizing="dynamic">
            <mat-label>{{'ZONE.MIN_BURDEN' | translate}}</mat-label>
            <input matInput type="number" formControlName="minBurden" step="0.1" min="0" />
          </mat-form-field>
        </div>

        <div class="zone-field">
          <mat-form-field appearance="outline" class="zone-mat-field" subscriptSizing="dynamic">
            <mat-label>{{'ZONE.DIAMETER' | translate}}</mat-label>
            <input matInput type="number" formControlName="diameter" step="1" min="0" />
          </mat-form-field>
        </div>

        <div class="zone-field">
          <mat-form-field appearance="outline" class="zone-mat-field" subscriptSizing="dynamic">
            <mat-label>{{'ZONE.INCLINATION' | translate}}</mat-label>
            <input matInput type="number" formControlName="inclination" step="1" />
          </mat-form-field>
        </div>

        <div class="zone-field">
          <mat-form-field appearance="outline" class="zone-mat-field" subscriptSizing="dynamic">
            <mat-label>{{'ZONE.SUBDRILL' | translate}}</mat-label>
            <input matInput type="number" formControlName="subdrill" step="0.1" min="0" />
          </mat-form-field>
        </div>

      </div>

      <!-- Action bar -->
      @if (isModified()) {
        <div class="zone-actions">
          <button type="submit" mat-flat-button color="primary" class="zone-action-btn">
            <mat-icon>check</mat-icon>
            {{'GLOBAL.VALIDER' | translate}}
          </button>
          <button type="button" mat-stroked-button class="zone-action-btn" (click)="onCancel()">
            <mat-icon>close</mat-icon>
            {{'GLOBAL.ANNULER' | translate}}
          </button>
        </div>
      }

    </form>

    <!-- ── Table ── -->
    <div class="zone-table-wrapper">
      <table mat-table [dataSource]="dataSource()" matSort class="zone-table">

        <ng-container matColumnDef="nom">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'GLOBAL.NOM' | translate}}</th>
          <td mat-cell *matCellDef="let zone">{{ zone.nom }}</td>
        </ng-container>

        <ng-container matColumnDef="isActif">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-center">{{'GLOBAL.ACTIF' | translate}}</th>
          <td mat-cell *matCellDef="let zone" class="col-center">
            @if (zone.isActif) {
              <mat-icon class="checkbox-epc-green icon-sm">check_circle</mat-icon>
            } @else {
              <mat-icon class="checkbox-epc-red icon-sm">remove_circle</mat-icon>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="burden">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-end">{{'ZONE.BURDEN' | translate}}</th>
          <td mat-cell *matCellDef="let zone" class="col-end">{{ zone.burden != null ? (zone.burden | number:'1.0-1') : '–' }}</td>
        </ng-container>

        <ng-container matColumnDef="spacing">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-end">{{'ZONE.SPACING' | translate}}</th>
          <td mat-cell *matCellDef="let zone" class="col-end">{{ zone.spacing != null ? (zone.spacing | number:'1.0-1') : '–' }}</td>
        </ng-container>

        <ng-container matColumnDef="minBurden">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-end">{{'ZONE.MIN_BURDEN' | translate}}</th>
          <td mat-cell *matCellDef="let zone" class="col-end">{{ zone.minBurden != null ? (zone.minBurden | number:'1.0-1') : '–' }}</td>
        </ng-container>

        <ng-container matColumnDef="diameter">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-end">{{'ZONE.DIAMETER' | translate}}</th>
          <td mat-cell *matCellDef="let zone" class="col-end">{{ zone.diameter != null ? zone.diameter : '–' }}</td>
        </ng-container>

        <ng-container matColumnDef="inclination">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-end">{{'ZONE.INCLINATION' | translate}}</th>
          <td mat-cell *matCellDef="let zone" class="col-end">{{ zone.inclination != null ? zone.inclination : '–' }}</td>
        </ng-container>

        <ng-container matColumnDef="subdrill">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-end">{{'ZONE.SUBDRILL' | translate}}</th>
          <td mat-cell *matCellDef="let zone" class="col-end">{{ zone.subdrill != null ? (zone.subdrill | number:'1.0-1') : '–' }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let zone; columns: displayedColumns"
          (click)="selectZone(zone)" class="cursor-pointer"
          [class.zone-row--active]="isEditMode() && originalZone()?.zoneId === zone.zoneId"></tr>

        <tr class="mat-mdc-no-data-row" *matNoDataRow>
          <td [attr.colspan]="displayedColumns.length" class="no-data-cell">
            {{'ZONE.NO_DATA' | translate}}
          </td>
        </tr>

      </table>
    </div>

  </div>
}
